import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "conversion",
  "use": "conversion-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"conversion\"><path fill=\"none\" d=\"M.1-.3h400v400H.1z\" /><path d=\"M321.8 105.6H103.5c-2.5 0-4.7 1.4-5.8 3.6s-.8 4.9.7 6.8l79.1 103.9v77.4c0 2.4 1.3 4.6 3.4 5.7 1 .5 2 .8 3.1.8 1.3 0 2.5-.4 3.6-1.1l32.2-21.3c1.8-1.2 2.9-3.2 2.9-5.4v-56.2l77.2-101.4h22c3.6 0 6.5-2.9 6.5-6.5s-3-6.3-6.6-6.3zM211 213.8c-.9 1.1-1.3 2.5-1.3 3.9v54.9l-19.2 12.7v-67.5c0-1.4-.5-2.8-1.3-3.9l-72.5-95.2h166.8L211 213.8z\" fill=\"#39485b\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol